module.exports = __webpack_public_path__ + "img/no-search.18b1e28a.png";